export enum TicketTypeSortType {
    Id,
    Name,
    IsDeleted
}
